module.exports = "/_next/static/images/3495a1dc51d1fe4875bb8468a73e6f9f-cfe-icon.svg.webp";